exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-form-field {\n  width: 100%;\n}\n\nagm-map {\n  height: 286px;\n  width: 237px;\n}\n\nmd-list {\n  max-height: 80vh;\n  max-width: 90vh;\n  min-width: 200px;\n}\n\nmd-list-item {\n  margin: 10px -16px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/components/complex-input/complex-input.component.css
// module id = ../../../../../src/app/components/complex-input/complex-input.component.css
// module chunks = main